import { Container, Row, Col } from "react-bootstrap";

const SECTIONS = [
  {
    h: "1. Introduction",
    p: [
      "We respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use and safeguard data when you visit our website.",
      "By using our site, you agree to the practices described in this policy.",
    ],
  },
  {
    h: "2. Information We Collect",
    list: [
      "Information you provide voluntarily, such as your name, email and message when you use our contact form.",
      "Usage data such as pages visited, time spent and general location, collected automatically.",
      "Cookies and similar technologies that help us understand how the site is used.",
    ],
  },
  {
    h: "3. How We Use Your Information",
    list: [
      "To respond to your enquiries and provide support.",
      "To improve our content, calculators and overall user experience.",
      "To analyse traffic and usage trends in an aggregated, anonymous way.",
      "To comply with legal obligations where applicable.",
    ],
  },
  {
    h: "4. Cookies",
    p: [
      "We use cookies to enhance your browsing experience and analyse site traffic. You can disable cookies through your browser settings, though some features may not function correctly as a result.",
    ],
  },
  {
    h: "5. Third-Party Services",
    p: [
      "We may use trusted third-party services (such as analytics providers) that collect data according to their own privacy policies. We do not sell your personal information to anyone.",
    ],
  },
  {
    h: "6. Data Security",
    p: [
      "We take reasonable technical and organisational measures to protect your information. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    h: "7. Educational Disclaimer",
    p: [
      "All content on our site is for educational and informational purposes only and does not constitute financial, investment, legal or tax advice. We are not a SEBI-registered investment adviser. Always consult a qualified professional before making financial decisions.",
    ],
  },
  {
    h: "8. Your Rights",
    p: [
      "You may request access to, correction of, or deletion of your personal data by contacting us. We will respond to reasonable requests in line with applicable law.",
    ],
  },
  {
    h: "9. Changes to This Policy",
    p: [
      "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.",
    ],
  },
  {
    h: "10. Contact Us",
    p: [
      "If you have any questions about this Privacy Policy, please reach out via our Contact page or email support@brnofilmfestival.com",
    ],
  },
];

function PrivacyPolicy() {
  return (
    <Container className="py-5">
      <div className=" mb-2">
        <h1 className="fi-about-heading" style={{ fontSize: "2.4rem" }}>Privacy Policy</h1>
      </div>
      <Row className="">
        <Col lg={9} className="fi-article">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2>{s.h}</h2>
                {s.p && s.p.map((para, i) => <p key={i}>{para}</p>)}
                {s.list && (
                  <ul>
                    {s.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
        </Col>
      </Row>
    </Container>
  );
}

export default PrivacyPolicy;
